import { render, staticRenderFns } from "./NewQuestion.vue?vue&type=template&id=7236e6de&"
import script from "./NewQuestion.vue?vue&type=script&lang=js&"
export * from "./NewQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports